import React, { useMemo, useRef } from "react";
import classNames from "classnames";
import { PopoverContainer, PopoverContainerHandle } from "../PopoverContainer";
import { AggregatedAccountsFilter } from "../AggregatedFilters/AccountFilter/AggregatedAccountsFilter";
import { UseFinancialAccountsOptions } from "../../../hooks/useFinancialAccounts";
import { ButtonProps } from "../Button/ButtonCore";
import { AccountsFilterAccountValueDisplay } from "./AccountsFilterAccountValueDisplay";
import styles from "./AccountsFilter.module.scss";

interface AccountsDropdownProps extends UseFinancialAccountsOptions {
    disabled?: boolean;
    accountIds: number[];
    onChange: (accountIds: number[]) => void;
    buttonSize?: ButtonProps["size"];
}

export const AccountsDropdown: React.FC<AccountsDropdownProps> = ({
    onChange,
    disabled,
    accountIds,
    buttonSize,
    ...options
}) => {
    const ref: React.ForwardedRef<PopoverContainerHandle | null> = useRef(null);
    const label = useMemo(
        () => (
            <div
                className={classNames(
                    styles.dropdownLabelContainer,
                    "d-flex gap-2",
                )}
            >
                <AccountsFilterAccountValueDisplay
                    isAccountSelected={(accountId) =>
                        accountIds.includes(accountId)
                    }
                    showSelectedIcons={true}
                    isSingleSelect={options.isSingleSelect}
                />
            </div>
        ),
        [accountIds, options.isSingleSelect],
    );

    return (
        <PopoverContainer
            disabled={disabled}
            id="accounts-filter"
            buttonText={label}
            buttonSize={buttonSize ?? "lg"}
            offset={4}
            ref={ref}
        >
            <AggregatedAccountsFilter
                filters={{
                    accountIds,
                }}
                onChange={(newFilters) => {
                    onChange(newFilters.accountIds ?? []);
                    if (options.isSingleSelect) {
                        ref.current?.close();
                    }
                }}
                {...options}
            />
        </PopoverContainer>
    );
};
